import { Box, Skeleton, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { getAiraloBalance } from "services/esim";
import { getApiError } from "services/finance";
import { formatUsd } from "utils/helpers";

// Prepaid Airalo credit. A low balance is the usual reason orders fail.
const AiraloBalance = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["airaloBalance"],
    queryFn: getAiraloBalance,
  });

  return (
    <Box bgcolor="#FFFFFF" border="1px solid #E4E7EC" borderRadius="12px" p="12px 20px">
      <Typography fontSize={12} color="#667085">
        Airalo balance
      </Typography>
      {isLoading ? (
        <Skeleton width={100} height={32} />
      ) : error ? (
        <Typography fontSize={13} color="#B42318">
          {getApiError(error, "Couldn't load balance")}
        </Typography>
      ) : (
        <Typography fontSize={20} fontWeight={600} color="#101828">
          {data == null ? "—" : formatUsd(data)}
        </Typography>
      )}
    </Box>
  );
};

export default AiraloBalance;
